import { Fragment, useContext, useState } from "react";
import Pagination from "react-js-pagination";
import useConfiguration from "../../hooks/useConfiguration";
import { archievedInboxMsg, deleteInboxMsgData, getEmailDetails, sendAllEmailbtn, sendEmail, updateInboxStatus } from "./action";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Accordion, AccordionContext, Button, Card, Collapse, Form, ListGroup, Row, useAccordionButton } from "react-bootstrap";
import EmailModal from "../common/Modal/EmailModal";
import { toast } from "react-toastify";
import useSessionStorage from "../../hooks/useSessionStorage";
import "./index.css";
import EmailReply from "../common/Modal/emailReply";
import { getNotificationCounts } from '../NotificationHeader/action';
import {ImAttachment} from 'react-icons/im'
const Inbox = ({
  content,
  isOpen,
  toggle,
  removeInboxMsg,
  inboxStatusHandler,
  archiveInboxHandler
}) => {
  const regex = /(<([^>]+)>)/ig;
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  // Email state 
  const [emailModalInd, setEmailModalInd] = useState(false);
  const [emailModalData, setEmailModalData] = useState([]);
  const [emailModalGetData, setEmailModalGetData] = useState({ subject: "" });
  const [emailModalList, setEmailModalList] = useState([]);
  const [emailHistoryMainPageFlag, setEmailHistoryMainPageFlag] = useState(false);
  const [replyModal, setReplyModal] = useState({ flag: false, id: "", data: {} });
  // Show Email Modal popup
  const showEmailModal = async (data) => {
    getEmailModalData("subject", data?.subject);
    if (emailModalInd) {
      setEmailModalList([]);
      setEmailHistoryMainPageFlag(false);
    } else {
      const emailDetailsResult = await dispatch(
        getEmailDetails({
          url: `${config.baseUrl}/Messaging/get-email-messages/${data.candidateUniqueId}`,
        }),
      );
      setEmailModalList(emailDetailsResult);
      setEmailHistoryMainPageFlag(true);
    }
    console.log(data);
    setEmailModalData(data);
    setEmailModalInd((preVal) => !preVal);
  };

  // Text box value sepetare 
  const valueJoinWithComma = (inputValue, key) => {
    let returnValue = "";
    if (!inputValue) return returnValue;
    if (!key) {
      returnValue = inputValue?.join(",");
    } else {
      returnValue = inputValue?.map && inputValue?.map((e) => e[key]).join(",");
    }
    return returnValue;
  };

  // Save Method Email modal popup
  const saveEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId:
          emailModalData?.candidateUniqueId,
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        ParentId: content?.messageTrackingId,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-email-to-candidate`,
          params: requestBody,
        }),
      );
      setEmailHistoryMainPageFlag(false);
      showEmailModal();
    } else {
      toast.error('Subject field is required')
    }
  };

  // get a Email details Method modal poup
  const getEmailModalData = (index, value) => {
    setEmailModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Send All for Email
  const sendAllEmail = () => {
    dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Messaging/sendallemails`)).then((res) => {
      if (res.status === 200) {
        toast.success('Email sent successfully!')
      } else {
        toast.error('Email Not sent!')
      }
    })
    showEmailModal();
  };

  // Email Read
  const sendReadEmail = () => {
    if (config.baseUrl) {
      dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Email/email-read-by-Graph`))
        .then((res) => {
          if (res.status === 200) {
            toast.success('Employer Email details updated successfully')
          } else {
            toast.error('Employer Email details are not updated')
          }
        })
    }
    showEmailModal();
  };

  const downloadUploadDoc = async (filename, docId, { url }) => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
    };
    fetch(`${config.baseUrl}/${url}${JSON.stringify(docId)}`, {
      headers: requestHeaders,
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
  };

  const openReplyModal = (id, val) => {
    if (id && val) {
      setReplyModal({ flag: true, id: id, data: val });
    }
  };

  const closeReplyModal = () => {
    setReplyModal({ flag: false, id: "", data: {} });
  };

  
  // Custom Toggle for Inside Multi Thread Message
  function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey);
    return (
      <div
        style={{cursor: 'pointer'}}
        className="col"
        onClick={() => {
          decoratedOnClick();
        }}
      >
        {children}
      </div>
    );
  }

    // Initially set all indices to be open
    const [openIndices, setOpenIndices] = useState(
      content?.getEmailInboxMessagesAllLists.map((_, index) => index)
    );
  
    const handleToggleInsideMail = (index) => {
      setOpenIndices((prevOpenIndices) => {
        if (prevOpenIndices.includes(index)) {
          // Close the index if it's already open
          return prevOpenIndices.filter((i) => i !== index);
        } else {
          // Open the index if it's closed
          return [...prevOpenIndices, index];
        }
      });
    };
    const [singleThreadOpenKey, setSingleThreadOpenKey] = useState(true);


    const [activeKey, setActiveKey] = useState('0'); // Default to '0' to keep it open initially

    // Function to toggle the accordion
    const handleToggle = () => {
      setActiveKey(prevKey => (prevKey === '0' ? null : '0')); // Toggle between open and closed
    };

    const handleOpenAll = () => {
      setOpenIndices(content?.getEmailInboxMessagesAllLists.map((_, index) => index));
      setActiveKey(prevKey => (prevKey === '0' ? "0" : '0'));
    };

    // Email download blob compare a parent to child
    const commonElements =   content?.messageTrackingAttachments.filter(element1 =>
      content?.getEmailInboxMessagesAllLists.some(element2 => element1.messageTrackingId === element2.messageTrackingId)
    );

    let singleThreadToggle;

    // Single Thread toggle open
    function ContextAwareToggle({ children, eventKey, callback }) {
      const { activeEventKey } = useContext(AccordionContext);
    
      const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
      );
      singleThreadToggle = decoratedOnClick
      const isCurrentEventKey = activeEventKey === eventKey;
      setSingleThreadOpenKey(isCurrentEventKey);
      return (
        <div
          className="col"
        >
          {children}
        </div>
      );
    }

  return (
    <>
      {/* <EmailModal
        showModal={emailModalInd}
        handleClose={showEmailModal}
        data={emailModalData}
        handleSave={saveEmailModal}
        handleForm={getEmailModalData}
        formData={emailModalGetData}
        listData={emailModalList}
        sendAllEmail={sendAllEmail}
        sendReadEmail={sendReadEmail}
        emailHistoryMainPageFlag={emailHistoryMainPageFlag}
      /> */}

      <EmailReply
        showModal={replyModal.flag}
        closeModal={closeReplyModal}
        candidateUniqueId={replyModal.id}
        data={replyModal.data}
      />
            <tr>
              <td style={{fontSize:"0.85rem"}}>
                <div class="d-flex align-items-center ">
                  <span onClick={() => {toggle()
                    handleOpenAll()
                  }} role="button" className="me-2">
                    {isOpen ? (
                      <i
                        class="fa fa-angle-down"
                        style={{ fontSize: "24px" }}
                      ></i>
                    ) : (
                      <i
                        onClick={() => {
                          if (content?.isRead !== 1) {
                            inboxStatusHandler({
                              status: 1,
                              notifyId: content?.messageTrackingId,
                              candidateUniqueId: content?.candidateUniqueId,
                              employerUniqueId: content?.employerUniqueId
                            });
                          }
                        }}
                        class="fa fa-angle-right"
                        style={{ fontSize: "24px" }}
                      ></i>
                    )}
                  </span>
                  {content?.isRead !== 1 && (
                    <>
                    {content?.getEmailInboxMessagesAllLists?.length > 0 ?
                    <span
                      className="text-center bg-danger text-white rounded-2 p-1 me-2 "
                      style={{ fontSize: "10px" }}
                    >
                      New
                    </span> : ''
                    
                    }
                    </> 
                  )}
                  {/* <span className="">
                 {content?.communicationType}
                </span> */}
                  <span className="d-flex flex-column">
                    <span>{content?.candidateName}</span>
                    <span>{content?.candidateEmail}</span>
                  </span>
                </div>
              </td>
              {/* <td className="col-2">
              <span className="d-flex flex-column">
                    <span>{content?.candidateName}</span>
                    <span>{content?.candidateEmail}</span>
                  </span>
              </td> */}
              <td style={{fontSize:"0.85rem"}}>
                {content?.subject}
              </td>
              <td style={{fontSize:"0.85rem"}}>
                <span className="dangerouse_render_truncate" dangerouslySetInnerHTML={{ __html: content?.message }}></span>
              </td>
          <td style={{fontSize:"0.85rem"}}>{content?.messageDateTime}</td>
          <td style={{fontSize:"0.85rem"}}>
            {content?.fromCandidate && 
            <>
            {!content?.isArchived ?
            <span style={{ cursor: 'pointer', }} className="text-info" onClick={() =>
                  openReplyModal(
                    content?.candidateUniqueId,
                    {
                      messageTrackingId: content?.messageTrackingId,
                      messageSubject: content?.subject,
                      messageBody: content?.message,
                      messageFrom: content?.messageFrom,
                      messageTo: content?.messageTo,
                      messageDate: content?.messageDateTime,
                      fromName: content?.messageFromName,
                      toName: content?.messageToName,
                      parentId: content?.parentId
                    }
                  )
                }><i className="fa fa-reply fa-lg fw-bold " style={{color: '#004D40'}}></i></span> : ''
              }
                </> 
                
                }
              </td>
              <td style={{fontSize:"0.85rem"}}>
                {content?.isRead === 1 ? (
                  <span
                    onClick={() =>
                      inboxStatusHandler({
                        status: 0,
                        notifyId: content?.messageTrackingId,
                        candidateUniqueId: content?.candidateUniqueId,
                        employerUniqueId: content?.employerUniqueId
                      })
                    }
                    style={{ cursor: "pointer" ,  gap: "0.5rem", pointerEvents: content?.getEmailInboxMessagesAllLists?.length > 0 ? '' : 'none'}}
                    className="d-flex align-items-center"
                  >
                    <i className="bi bi-envelope-open fa-lg text-primary"></i> 
                    <span>Read</span>
                  </span>

                ) : (
                  <span
                    onClick={() =>
                      inboxStatusHandler({
                        status: 1,
                        notifyId: content?.messageTrackingId,
                        candidateUniqueId: content?.candidateUniqueId,
                        employerUniqueId: content?.employerUniqueId
                      })
                    }
                    style={{ cursor: "pointer" ,  gap: "0.5rem", pointerEvents: content?.getEmailInboxMessagesAllLists?.length > 0 ? '' : 'none'}}
                  className="d-flex align-items-center"
                  >
                    <i class="bi bi-envelope fa-lg text-primary"></i> 
                    <span>Mark as Read</span>
                  </span>
                )}

              </td>
              <td style={{fontSize:"0.85rem"}}>
                {
                  content?.isArchived ?  <span
                  style={{ gap: "0.5rem" }}
                  className="d-flex align-items-center"
                  role="button"
                  onClick={() => archiveInboxHandler({status:0, notifyId:content?.messageTrackingId})}
                >
                  <i class="fa fa-archive fa-lg text-primary"></i> 
                  <span>Unarchive</span>
                </span> :  <span
                  style={{ gap: "0.5rem" }}
                  className="d-flex align-items-center"
                  role="button"
                  onClick={() => archiveInboxHandler({status:1, notifyId:content?.messageTrackingId})}
                >
                  <i class="fa fa-archive fa-lg text-primary"></i> 
                  <span>Archive</span>
                </span>
                }
              </td>
              <td >
                <i
                  role="button"
                  style={{ cursor: "pointer", fontSize: "1rem" }}
                  onClick={() => removeInboxMsg(content.messageTrackingId, content?.candidateUniqueId, login?.employerUniqueId)}
                  class="text-primary fe fe-trash-2"
                ></i>
              </td>
        </tr>

      {/* details */}
     
      <td colSpan={8}>
      <Collapse in={isOpen} className="content">
        <div className="row mt-3 ms-4">
        
          <span className="fw-bolder">
            {/* <h4>Email Info</h4> */}
          </span>

        {content?.getEmailInboxMessagesAllLists?.length > 0 ?
          <Accordion activeKey={openIndices.map((i) => i.toString())}>
      {content?.getEmailInboxMessagesAllLists.map((item, index) => (
        <Card className="mb-0" key={index}>
          <Card.Header
            style={item?.fromCandidate ? { backgroundColor: '#FFD300' } : {}}
          >
            <CustomToggle eventKey={index.toString()}>
              <div
                className="row"
                aria-controls={`collapse-${index}`}
                aria-expanded={openIndices.includes(index)}
              >
                <div className={`col-3 d-flex ${openIndices.includes(index) ? 'gap-2' : 'gap-3'}`}>
                  <div onClick={() => handleToggleInsideMail(index)}>
                    <i className={`fa ${openIndices.includes(index) ? 'fa-angle-down' : 'fa-angle-right'}`} style={{ fontSize: '24px' }}></i>
                  </div>
                  <div className="">{item.candidateEmail}</div>
                </div>
                <div className="col-6">{item.subject}</div>
                <div className="col-1">
                {item?.fromCandidate && 
            <>
            {!item?.isArchived ?
            <span style={{ cursor: 'pointer', }} className="text-info" onClick={() =>
                  openReplyModal(
                    item?.candidateUniqueId,
                    {
                      messageTrackingId: item?.messageTrackingId,
                      messageSubject: item?.subject,
                      messageBody: item?.message,
                      messageFrom: item?.messageFrom,
                      messageTo: item?.messageTo,
                      messageDate: item?.messageDateTime,
                      fromName: item?.messageFromName,
                      toName: item?.messageToName,
                      parentId: item?.parentId
                    }
                  )
                }><i className="fa fa-reply fa-lg fw-bold " style={{color: '#004D40'}}></i></span> : ''
              }
                </> 
                
                }
                </div>
                <div className="col-2">
                  {item?.messageDateTime}
                </div>
              </div>
            </CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey={index.toString()}>
            <Card.Body>
            <>
            <div className="mb-3">
              <div className='ms-2'>From: {`${item?.messageFromName}<${item?.messageFrom}>`}</div> 
              <div className='ms-2'>Sent: {item?.messageDateTime}</div>
              <div className='ms-2'>To: {`${item?.messageToName} <${item?.messageTo}>`}</div>
              <div className='ms-2'>Subject: {item?.subject}</div>
          </div>
            <div dangerouslySetInnerHTML={{__html: item?.message}}></div>
                                        
          <td className="text-wrap mb-2" colSpan={6}>
          {commonElements
            ?.length > 0
            ? commonElements?.map(
              (blob) => {
                return (
                  item?.messageTrackingId === blob?.messageTrackingId ? 
                  <div
                    rel="noreferrer"
                    style={{
                      cursor: "pointer",
                      marginRight:"1rem",
                      marginBottom:"1rem",
                      // display:"inline-block"
                    }}
                    onClick={() =>
                      downloadUploadDoc(
                        blob?.attachedFilename,
                        blob?.messageTrackingAttachmentId,
                        {
                          url: "Messaging/download-Message-file-tracking-document?MessageTrackingAttachmentId=",
                        }
                      )
                    }
                  >
                    <i>
                    <ImAttachment />-{blob?.attachedFilename}-<i
                      className="mdi mdi-arrange-bring-forward"
                      data-bs-toggle="tooltip"
                      title=""
                      data-bs-original-title="mdi-arrange-bring-forward"
                      aria-label="mdi-arrange-bring-forward"
                    ></i>
                    </i>
                  </div> : ''
                );
              }
            )
            : ""}
          </td>
                                        
                  </>      
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  
      : 
      <>
        <Accordion activeKey={activeKey}>
      <Card>
        <Card.Header>
          <ContextAwareToggle eventKey={'0'}>
          <div
                className="row"
              >
                <div className={`col-4 d-flex gap-2`}>
                  <i className={`fa ${singleThreadOpenKey ? 'fa-angle-down' : 'fa-angle-right'}`} style={{fontSize: '24px'}} onClick={() => handleToggle()}></i>
                  <div className="">{content.candidateEmail}</div>
                </div>
                <div className="col-4">{content.subject}</div>
                <div className="col-1">
                {content?.fromCandidate && 
            <>
            {!content?.isArchived ?
            <span style={{ cursor: 'pointer', }} className="text-info" onClick={() =>
                  openReplyModal(
                    content?.candidateUniqueId,
                    {
                      messageTrackingId: content?.messageTrackingId,
                      messageSubject: content?.subject,
                      messageBody: content?.message,
                      messageFrom: content?.messageFrom,
                      messageTo: content?.messageTo,
                      messageDate: content?.messageDateTime,
                      fromName: content?.messageFromName,
                      toName: content?.messageToName,
                      parentId: content?.parentId
                    }
                  )
                }><i className="fa fa-reply fa-lg fw-bold " style={{color: '#004D40'}}></i></span> : ''
              }
                </> 
                }
                </div>
                <div className="col-2">
                  {content?.messageDateTime}
                </div>
              </div>
              </ContextAwareToggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
          <>
      <div className="row"> 
        <>
          <div className='ms-2'>From: {`${content?.messageFromName}<${content?.messageFrom}>`}</div> 
          <div className='ms-2'>Sent: {content?.messageDateTime}</div>
          <div className='ms-2'>To: {`${content?.messageToName} <${content?.messageTo}>`}</div>
          <div className='ms-2'>Subject: {content?.subject}</div>
        </>
        <div className="mt-3" dangerouslySetInnerHTML={{ __html: content?.message }}></div>
      </div>
      <td className="text-wrap mb-2" colSpan={6}>
      {content?.messageTrackingAttachments
        ?.length > 0
        ? content?.messageTrackingAttachments?.map(
          (item) => {
            return (
              <div>
              <span
                rel="noreferrer"
                style={{
                  cursor: "pointer",
                  marginRight:"1rem",
                  marginBottom:"1rem",
                  display:"inline-block"
                }}
                onClick={() =>
                  downloadUploadDoc(
                    item?.attachedFilename,
                        item?.messageTrackingAttachmentId,
                    {
                      url: "Messaging/download-Message-file-tracking-document?MessageTrackingAttachmentId=",
                    }
                  )
                }
              >
                <i>
                <ImAttachment />-{item?.attachedFilename}-<i
                  className="mdi mdi-arrange-bring-forward"
                  data-bs-toggle="tooltip"
                  title=""
                  data-bs-original-title="mdi-arrange-bring-forward"
                  aria-label="mdi-arrange-bring-forward"
                ></i>
                </i>
              </span>
              </div>
            );
          }
        )
        : ""}
      </td>
      </>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      </Accordion>
      </>
      }
        </div>
      </Collapse>
      </td>
      
    </>
  );
};

const AccordianTable = (props) => {
  const { handlePageChange, currentPage, pageSize, totalCount, handlePageSize } = props;
  const [isOpen, setIsOpen] = useState(null);
  //   const [openMessaging, setOpenMessaging] = useState(false);
  //   const [chatData, setChatData] = useState([]);
  const [inboxParams, setInboxParams] = useState({
    webPageId: 0,
    shiftUniqueId: "",
    candidateUniqueId: "",
    employerUniqueId: "",
  });
  const config = useConfiguration();
  const dispatch = useDispatch()

  const toggleOpen = (id) => () => {
    setIsOpen((isOpen) => (isOpen === id ? null : id));
  };

  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const inboxStatusHandler = ({ status, notifyId, candidateUniqueId, employerUniqueId }) => {
    const inboxStatusParams = {
      "messageTrackingId": notifyId,
      "markAsMessageRead": status,
      candidateUniqueId,
      "communicationTypeEnum": "Email",
      employerUniqueId: login?.employerUniqueId
    }
    dispatch(updateInboxStatus({
      url: config.baseUrl,
      inboxStatusParams
    })).then(() => {
      dispatch(getNotificationCounts(config.baseUrl))
    })
  };
  const archiveInboxHandler = ({ status, notifyId }) => {
    const inboxStatusParams = {
      messageTrackingId: notifyId,
      isArchived: status,
    };
    dispatch(
      archievedInboxMsg({
        url: config.baseUrl,
        inboxStatusParams,
      })
    ).then(() => {
      dispatch(getNotificationCounts(config.baseUrl));
    });
  };

  const removeInboxMsg = (inboxMsgId, candidateUniqueId, employerUniqueId) => {
    dispatch(deleteInboxMsgData({
      url: config.baseUrl,
      inboxMsgId: inboxMsgId,
      candidateUniqueId: candidateUniqueId,
      employerUniqueId: employerUniqueId
    }))
  }
  return (
    <div className="card" style={{maxHeight: '1080px', overflow: 'scroll'}}>
      <div className="card-header">
        <div className="col-lg-4 col-md-4">
          <h5 className="card-title">Emails</h5>
        </div>
      </div>
      <div className="card-body">
        <div className="d-inline-flex align-items-center ">
          <label class="mb-0 pe-2">Show</label>
          <select
            name="myTable_length"
            class="form-control form-select"
            value={pageSize}
            aria-controls="myTable"
            onChange={(e) => handlePageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
          <span className="Entries"> entries</span>
        </div>
        <div className="table-scrollable table-responsive">
          <table
            id="myTable"
            className="table dataTable girdtable no-footer scrollme"
            role="grid"
            aria-describedby="myTable_info"
          >
            <thead>
              <tr role="row">
                {props?.headerList.map((column) => (
                  <th
                    className="reset_start"
                    tabIndex="0"
                    aria-controls="myTable"
                    rowSpan="1"
                    colSpan="1"
                    style={{border:"none"}}
                  >
                    <div
                      className="d-flex gap-2"
                      style={{
                        height: "0px",
                        width: column?.width ? `${column?.width}px`:"",
                        maxWidth: column?.maxWidth ? `${column?.maxWidth}px`:"",
                      }}
                    >
                      <div style={{ visibility: "hidden" }} className="">
                        {column?.Header}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
            {props.inboxData &&
              props.inboxData.length > 0 &&
              props.inboxData.map((item, index) => (
                <Inbox
                  key={index}
                  content={item}
                  isOpen={isOpen === index}
                  toggle={toggleOpen(index)}
                  removeInboxMsg={removeInboxMsg}
                  inboxStatusHandler={inboxStatusHandler}
                  archiveInboxHandler = {archiveInboxHandler}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div
          className="dataTables_info ps-3"
          id="myTable_info"
          role="status"
          aria-live="polite"
        >
          Showing Page{" "}
          <strong>
            {currentPage} of {Math.ceil(totalCount / pageSize)}
          </strong>
        </div>
        <div class="pe-3 mb-4">
          <Pagination
            itemClass="page-item" // add it for bootstrap 4
            linkClass="page-link" // add it for bootstrap 4
            activePage={currentPage}
            itemsCountPerPage={pageSize}
            totalItemsCount={totalCount}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AccordianTable;
